import RatingDriverDetail from './RatingDriverDetail';
export default RatingDriverDetail;
